import { PageSize } from "./packing-slip-builder";

export const PAGE_SIZE_LABELS: Record<PageSize, string> = {
  [PageSize.FULL_SIZE]: 'Full size (8.5" × 11")',
  [PageSize.HALF_SIZE]: 'Half size (5.5" × 8.5")',
  [PageSize.LABEL]: 'Label (4" × 6")',
  [PageSize.CARD_5X7]: 'Card (5" × 7")',
};
